/* GetSocked Pop — theme.js (no dependencies) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const R = window.GS?.routes || {};

  /* ---------- Money ---------- */
  const formatMoney = (cents) => {
    const fmt = window.GS?.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const [w, d] = value.split('.');
    const withCommas = w.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${w.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${d}`)
      .replace(/\{\{\s*amount\s*\}\}/, `${withCommas}.${d}`)
      .replace(/<[^>]*>/g, '');
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (msg) => {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* ---------- Overlay + drawers ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastFocus = null;

  const showOverlay = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    document.body.classList.add('is-locked');
  };
  const hideOverlay = () => {
    overlay.classList.remove('is-visible');
    document.body.classList.remove('is-locked');
    setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 250);
  };

  const open = (drawer) => {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) close(openDrawer, true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openDrawer = drawer;
    showOverlay();
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => ($('[data-drawer-close]', drawer) || drawer).focus(), 50);
  };
  const close = (drawer, keepOverlay) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (openDrawer === drawer) openDrawer = null;
    if (!keepOverlay) {
      hideOverlay();
      lastFocus?.focus?.();
    }
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); open(document.getElementById(opener.dataset.drawerOpen)); return; }
    if (e.target.closest('[data-drawer-close]')) { close(e.target.closest('[data-drawer]')); return; }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open($('#CartDrawer')); return; }
    if (e.target === overlay) { close(openDrawer); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (openDrawer) close(openDrawer);
    closeSearch();
  });

  /* ---------- Sticky header shadow ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach((rot) => {
    const msgs = $$('.utility__msg', rot);
    if (msgs.length < 2) return;
    let i = 0;
    const speed = parseInt(rot.dataset.speed, 10) || 5000;
    let timer = setInterval(next, speed);
    function next() {
      const cur = msgs[i];
      i = (i + 1) % msgs.length;
      cur.classList.add('is-leaving');
      cur.classList.remove('is-active');
      msgs[i].classList.remove('is-leaving');
      msgs[i].classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 600);
    }
    rot.addEventListener('mouseenter', () => clearInterval(timer));
    rot.addEventListener('mouseleave', () => { clearInterval(timer); timer = setInterval(next, speed); });
  });

  /* ---------- Horizontal scrollers + arrows ---------- */
  $$('[data-scroller-nav]').forEach((nav) => {
    const root = nav.closest('section') || document;
    const sc = $('[data-scroller]', root);
    if (!sc) return;
    const step = () => {
      const item = sc.firstElementChild;
      return item ? item.getBoundingClientRect().width + 20 : sc.clientWidth * 0.8;
    };
    const prev = $('[data-prev]', nav);
    const nextBtn = $('[data-next]', nav);
    const update = () => {
      prev.disabled = sc.scrollLeft <= 4;
      nextBtn.disabled = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4;
      nav.hidden = sc.scrollWidth <= sc.clientWidth + 4;
    };
    prev.addEventListener('click', () => sc.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => sc.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    sc.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Search modal + predictive search ---------- */
  const modal = $('[data-search-modal]');
  const input = $('[data-search-input]');
  const results = $('[data-search-results]');
  const defaultResults = results ? results.innerHTML : '';
  let searchAbort;

  function openSearch() {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('is-locked');
    setTimeout(() => input?.focus(), 30);
  }
  function closeSearch() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (!openDrawer) document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]') || e.target === modal) closeSearch();
  });

  let debounce;
  input?.addEventListener('input', () => {
    clearTimeout(debounce);
    const q = input.value.trim();
    if (!q) { results.innerHTML = defaultResults; return; }
    debounce = setTimeout(async () => {
      searchAbort?.abort();
      searchAbort = new AbortController();
      try {
        const url = `${R.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag&section_id=predictive-search`;
        const res = await fetch(url, { signal: searchAbort.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#shopify-section-predictive-search');
        results.innerHTML = inner ? inner.innerHTML : html;
      } catch (err) { /* aborted */ }
    }, 220);
  });

  /* ---------- Cart ---------- */
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  };

  const renderDrawer = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-inner]');
    const cur = $('[data-cart-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
  };

  const refreshCart = async () => {
    const [cart, sections] = await Promise.all([
      fetch(`${R.cart}.js`).then((r) => r.json()),
      fetch(`${R.root}?sections=cart-drawer`).then((r) => r.json())
    ]);
    updateCount(cart.item_count);
    renderDrawer(sections['cart-drawer']);
    return cart;
  };

  // Route add-to-cart clicks through our AJAX submit before third-party scripts can hijack the click
  window.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add-btn]');
    if (!b) return;
    const form = b.form || b.closest('form');
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (b.disabled || b.classList.contains('is-loading')) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }, true);

  // Add to cart (product page, cards, upsell)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btns = $$(`[data-add-btn]`, form).concat(form.id ? $$(`button[form="${form.id}"]`) : []);
    const err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    btns.forEach((b) => b.classList.add('is-loading'));
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      const res = await fetch(`${R.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      renderDrawer(data.sections?.['cart-drawer']);
      const cart = await fetch(`${R.cart}.js`).then((r) => r.json());
      updateCount(cart.item_count);
      btns.forEach((b) => { b.classList.add('is-added'); setTimeout(() => b.classList.remove('is-added'), 1400); });
      document.dispatchEvent(new CustomEvent('gs:cart:added', { detail: { item: data, cart } }));
      if (!form.closest('[data-cart-drawer]')) open($('#CartDrawer'));
    } catch (error) {
      if (err) { err.textContent = error.message; err.hidden = false; }
      else toast(error.message);
    } finally {
      btns.forEach((b) => b.classList.remove('is-loading'));
    }
  });

  // Quantity changes in drawer + cart page
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    const lineEl = btn.closest('[data-line]');
    const list = btn.closest('.cart-items');
    list?.classList.add('is-updating');
    try {
      const res = await fetch(`${R.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(lineEl.dataset.line, 10), quantity: parseInt(btn.dataset.lineChange, 10), sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not update cart');
      if (btn.closest('[data-cart-page]')) { window.location.reload(); return; }
      updateCount(data.item_count);
      renderDrawer(data.sections?.['cart-drawer']);
    } catch (error) {
      toast(error.message);
      list?.classList.remove('is-updating');
    }
  });

  // Keep drawer fresh when returning via back/forward cache
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('form[action*="/cart/add"]', root);
    const idInput = $('[data-variant-id]', root);

    // Quantity steppers
    $$('[data-qty]', root).forEach((q) => {
      const inp = $('input', q);
      $('[data-qty-minus]', q)?.addEventListener('click', () => { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); });
      $('[data-qty-plus]', q)?.addEventListener('click', () => { inp.value = (parseInt(inp.value, 10) || 1) + 1; });
    });

    // Gallery dots (mobile)
    const track = $('[data-gallery-track]', root);
    const dots = $$('[data-gallery-dots] button', root);
    if (track && dots.length) {
      const sync = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      };
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      dots.forEach((d, n) => d.addEventListener('click', () => track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' })));
    }

    // Variant picker
    const picker = $('[data-variant-picker]', root);
    if (picker && product) {
      picker.addEventListener('change', () => {
        const selected = $$('fieldset', picker).map((fs) => $('input:checked', fs)?.value);
        selected.forEach((v, i) => { const l = $(`[data-option-label="${i}"]`, picker); if (l) l.textContent = v; });
        const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        const labels = $$('[data-atc-label]', root);
        const btns = $$('[data-add-btn]', root);
        if (!variant) {
          btns.forEach((b) => (b.disabled = true));
          labels.forEach((l) => (l.textContent = 'Unavailable'));
          return;
        }
        if (idInput) idInput.value = variant.id;
        btns.forEach((b) => (b.disabled = !variant.available));
        labels.forEach((l) => (l.textContent = variant.available ? 'Add to cart' : 'Sold out'));
        $$('[data-price]', root).forEach((p) => {
          const now = $('.price__now', p);
          if (now) now.textContent = formatMoney(variant.price);
          let was = $('.price__was', p);
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          p.classList.toggle('price--sale', !!onSale);
          if (onSale) {
            if (!was) { was = document.createElement('s'); was.className = 'price__was'; now.after(was); }
            was.textContent = formatMoney(variant.compare_at_price);
          } else if (was) was.remove();
          const save = $('.price__save', p);
          if (save) save.hidden = !onSale;
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        if (variant.featured_media && track) {
          const slide = $(`[data-media-id="${variant.featured_media.id}"]`, track);
          if (slide) {
            if (window.matchMedia('(min-width: 990px)').matches) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            else track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        }
      });
    }

    // Sticky add-to-cart
    const sticky = $('[data-sticky-atc]', root);
    const mainAtc = $('[data-main-atc]', root);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(mainAtc);
    }
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        initScrollerNavs(el.closest('section'));
      } else el.closest('section')?.remove();
    } catch (e) { /* ignore */ }
  });

  function initScrollerNavs(scope) {
    $$('[data-scroller-nav]', scope).forEach((nav) => {
      const sc = $('[data-scroller]', scope);
      if (!sc) return;
      const w = () => (sc.firstElementChild?.getBoundingClientRect().width || 240) + 20;
      $('[data-prev]', nav).addEventListener('click', () => sc.scrollBy({ left: -w() * 2, behavior: 'smooth' }));
      $('[data-next]', nav).addEventListener('click', () => sc.scrollBy({ left: w() * 2, behavior: 'smooth' }));
    });
  }

  /* ---------- Collection: sort + filters + load more ---------- */
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    const submit = () => {
      const params = new URLSearchParams(new FormData(filterForm));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      window.location.href = `${filterForm.getAttribute('action')}?${params.toString()}`;
    };
    $('[data-sort]', filterForm)?.addEventListener('change', submit);
    filterForm.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more-btn]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      const html = await fetch(btn.href).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-grid]');
      $$('[data-grid] > li', doc).forEach((li) => grid.appendChild(li));
      const nextWrap = $('[data-load-more]', doc);
      const curWrap = $('[data-load-more]');
      if (nextWrap) curWrap.replaceWith(nextWrap); else curWrap.remove();
      window.history.replaceState({}, '', btn.href);
    } catch (err) {
      window.location.href = btn.href;
    }
  });

  /* ---------- Legacy "Read more" toggles inside collection/product descriptions ---------- */
  window.toggleReadMore = (btn) => {
    const wrap = btn.closest('.product-description-wrapper') || btn.parentElement;
    const more = wrap && wrap.querySelector('.more-text');
    if (!more) return;
    const hidden = more.style.display === 'none' || more.style.display === '' || getComputedStyle(more).display === 'none';
    more.style.display = hidden ? 'block' : 'none';
    btn.textContent = hidden ? 'Read less' : 'Read more...';
  };

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.section .section__head, .tiles > *, .promos > *, .quotes > *, .split__copy, .feature').forEach((el) => {
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('reveal'); io.observe(el); }
    });
  }

  /* ---------- Theme editor: open cart drawer when its section is selected ---------- */
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('[data-cart-drawer]')) open($('#CartDrawer'));
  });
})();
